import React, {
  Component
} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {
  Container,
  Header,
  Segment
} from 'semantic-ui-react';

class PortfolioView extends Component {

  constructor (props) {
    super(props);
  }

  render () {
    return (
      <CSSTransitionGroup
        transitionName="fadein"
        transitionAppear={true}
        transitionAppearTimeout={1000}
        transitionEnter={false}
        transitionLeave={false}>
        <Container fluid>
          <Segment size="massive" padded="very" textAlign="center">
            <Header as="h1">
              Portfolio
            </Header>
          </Segment>
        </Container>
      </CSSTransitionGroup>
    );
  }
}

export default PortfolioView;



// WEBPACK FOOTER //
// ./client/containers/PortfolioView.js